import { Button, Col, Divider, Form, Radio, Row, Slider, SliderSingleProps, Typography } from "antd";
import { FC, useEffect, useState } from "react";

const defaultFilterValues: any = {
  Prix: [400_000, 150_000_000],
  Usages: ["Appartement"],
  Date_Transaction: [1000, new Date().getFullYear()],
  SurfaceBrutHab: [0, 10_000],
};

const Filters: FC<{
  onApplyFilters: (filters: any) => void;
  displayContactUsModal: any;
  setOpenFilters: any;
}> = ({ onApplyFilters, displayContactUsModal, setOpenFilters }) => {
  const [form] = Form.useForm();
  const [filters, setFilters] = useState({});

  useEffect(() => handleFormValuesChange(defaultFilterValues), []);

  useEffect(() => {
    onApplyFilters(filters);
  }, [filters, onApplyFilters]);

  const handleFormValuesChange = (allValues: any) => {
    let filters: any[] = [];

    Object.keys(allValues).forEach((field) => {
      const value = allValues[field];

      // Skip undefined or null fields
      if (value === undefined || value === null) {
        return;
      }

      switch (field) {
        case "Prix":
          if (value[0] && value[0].length === 2) {
            filters.push({
              Prix: { _between: value[0] },
            });
          } else {
            filters.push({
              Prix: { _between: defaultFilterValues.Prix },
            });
          }
          break;

        case "Usages":
          if (value[0]?.includes("disable")) {
            form.setFieldValue("Usages", "NONE");
            filters.push({
              _or: [
                {
                  Usages: { _contains: "NONE" },
                },
              ],
            });
            displayContactUsModal();
          } else if (value && value.length > 0 && value[0]) {
            console.log(value);
            filters.push({
              _or: value.map((v: any) => ({
                Usages: { _contains: v },
              })),
            });
          } else {
            filters.push({
              _or: defaultFilterValues.Usages.map((v: any) => ({
                Usages: { _contains: v },
              })),
            });
          }
          break;

        case "Date_Transaction":
          console.log(value[0]);
          if (value[0] === undefined) {
            value[0] = [1000, currentYear];
          }
          if (value[0][0] < 2021) {
            value[0][0] = 1000;
            //displayContactUsModal();
          }
          console.log(value[0]);
          if (value[0] && value[0].length === 2) {
            filters.push({
              Date_Transaction: {
                _between: [
                  new Date(value[0][0], 0, 1).toISOString(),
                  new Date(value[0][1], 11, 31).toISOString(),
                ],
              },
            });
          } else {
            filters.push({
              Date_Transaction: {
                _between: [
                  new Date(
                    defaultFilterValues.Date_Transaction[0],
                    0,
                    1
                  ).toISOString(),
                  new Date(
                    defaultFilterValues.Date_Transaction[1],
                    11,
                    31
                  ).toISOString(),
                ],
              },
            });
          }
          break;

        case "SurfaceBrutHab":
          if (value[0] === undefined) {
            filters.push({
              SurfaceBrutHab: { _between: defaultFilterValues.SurfaceBrutHab },
            });
          }
          else if (value && value.length === 2) {
            filters.push({
              SurfaceBrutHab: { _between: value },
            });
          }
          else if (value.length===1 && value[0].length === 2) {
            filters.push({
              SurfaceBrutHab: {_between: value[0]}
            });
          } else {
            filters.push({
              SurfaceBrutHab: { _between: defaultFilterValues.SurfaceBrutHab },
            });
          }
          break;

        case "Terrain":
          if (value && value.length === 2) {
            filters.push({
              Terrain: { _between: value },
            });
          }
          break;

        default:
          break;
      }
    });

    console.log("Filters: ", filters);

    setFilters({
      _and: [
        ...filters,
        { Type: { _in: ["Achat"] } },
        { SurfaceBrutHab: { _gte: 1 } },
      ],
    });
  };

  const { Text } = Typography;

  const advancedSearchTitle: React.CSSProperties = {
    textTransform: "uppercase",
    fontWeight: "400",
  };

  const fakeDisabled: React.CSSProperties = {
    opacity: "0.5",
    color: "gray !important",
  };

  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 5;
  const dateMarks: Record<number, { label: string }> = {
    [startYear]: { label: `<${startYear}` },
  };
  for (let y = startYear + 1; y <= currentYear; y++) {
    dateMarks[y] = { label: String(y) };
  }

  const handleChange = (value: any) => {
    const [start] = value;
    if (start < startYear + 1) {
      value[0] = 1000;
    }
  };


  const formatter: NonNullable<SliderSingleProps['tooltip']>['formatter'] = (value) => value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\'');

  // Détection du mode desktop (iframe) vs mobile (ouverture directe)
  const isDesktopMode = window.self !== window.top;

  if (isDesktopMode) {
    // Mode desktop : layout avec filtres (2/3) + légendes (1/3)
    return (
      <div className="filters-form" style={{ display: "flex", gap: "0" }}>
        {/* Section filtres - 4/5 */}
        <div style={{ flex: "4", paddingRight: "24px" }}>
          <Form
            form={form}
            onFinish={(allValues) => handleFormValuesChange(allValues)}
          >
            <Row gutter={[48, 16]} justify="space-between">
              <Col xs={24} md={12}>
                <Text style={advancedSearchTitle}>Année de vente</Text>
                <Form.Item name={["Date_Transaction", 0]}>
                  <Slider
                    range
                    marks={dateMarks}
                    defaultValue={[startYear, currentYear]}
                    min={startYear}
                    max={currentYear}
                    onChange={handleChange}
                    step={1}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Text style={advancedSearchTitle}>Prix de vente</Text>
                <Form.Item name={["Prix", 0]}>
                  <Slider
                    range
                    defaultValue={[400000, 100000000]}
                    min={400000}
                    max={100000000}
                    step={250000}
                    tooltip={{formatter}}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Divider style={{ marginTop: 8 }} />

            <Row gutter={[48, 16]} justify="space-between">
              <Col xs={24} md={12}>
                <Text style={advancedSearchTitle}>Type de bien</Text>
                <Form.Item name={["Usages", 0]}>
                  <Radio.Group
                    options={[
                      {
                        label: "Maison",
                        value: "Habitation à un seul logement",
                        style: { flexBasis: "25%" },
                      },
                      {
                        label: "Appartement",
                        value: "Appartement",
                        style: { flexBasis: "45%" },
                      },
                      {
                        label: "Terrain",
                        value: "disabled1",
                        style: { flexBasis: "25%", ...fakeDisabled },
                      },
                      {
                        label: "Immeuble",
                        value: "disabled2",
                        style: { flexBasis: "25%", ...fakeDisabled },
                      },
                      {
                        label: "Bureaux",
                        value: "disabled3",
                        style: { flexBasis: "25%", ...fakeDisabled },
                      },
                    ]}
                    defaultValue={"Appartement"}
                    style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                    onChange={
                            (e) => {
                              if (e.target.value.includes('disabled')) {
                                displayContactUsModal();
                              }
                            }}
                          
                  ></Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Text style={advancedSearchTitle}>Surface</Text>
                <Form.Item name={["SurfaceBrutHab", 0]}>
                  <Slider
                    range
                    defaultValue={[0, 500]}
                    min={0}
                    max={500}
                    step={25}
                    tooltip={{formatter}}
                  />
                </Form.Item>
              </Col>
            </Row>
            <div style={{ display: 'flex', justifyContent: 'right' }}>
              <Button type="primary" htmlType="submit" onClick={() => setOpenFilters(false)}>
                OK
              </Button>
            </div>
          </Form>
        </div>

        {/* Trait de séparation vertical */}
        <div style={{ 
          width: "1px", 
          backgroundColor: "#e0e0e0", 
          margin: "0 24px" 
        }}></div>

        {/* Section légendes - 1/5 */}
        <div style={{ flex: "1", paddingLeft: "0px" }}>
          <Text style={{...advancedSearchTitle, marginBottom: "16px", display: "block"}}>
            Légende de la carte
          </Text>
          <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: "#7ED957",
                  flexShrink: 0
                }}
              />
              <span style={{ fontSize: "0.65rem", lineHeight: "1.1" }}>
                PRIX/m² DISPONIBLES ET ANALYSÉS
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: "#001482",
                  flexShrink: 0
                }}
              />
              <span style={{ fontSize: "0.65rem", lineHeight: "1.1" }}>
                TRANSACTIONS IMMOBILIERES DE TOUTES LES CATEGORIES D'ACTIFS (12 derniers mois)
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Mode mobile : layout original sans légendes
  return (
    <Form
      form={form}
      onFinish={(allValues) => handleFormValuesChange(allValues)}
      className="filters-form"
    >
      <Row gutter={[48, 16]} justify="space-between">
        <Col xs={24} md={12}>
          <Text style={advancedSearchTitle}>Date de vente</Text>
          <Form.Item name={["Date_Transaction", 0]}>
            <Slider
              range
              marks={dateMarks}
              defaultValue={[startYear, currentYear]}
              min={startYear}
              max={currentYear}
              onChange={handleChange}
              step={1}
            />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Text style={advancedSearchTitle}>Prix de vente</Text>
          <Form.Item name={["Prix", 0]}>
            <Slider
              range
              defaultValue={[650_000, 50_000_000]}
              min={650_000}
              max={50_000_000}
              step={250000}
              tooltip={{formatter}}
            />
          </Form.Item>
        </Col>
      </Row>

      <Divider style={{ marginTop: 8 }} />

      <Row gutter={[48, 16]} justify="space-between">
        <Col xs={24} md={12}>
          <Text style={advancedSearchTitle}>Type de bien</Text>
          <Form.Item name={["Usages", 0]}>
            <Radio.Group
              options={[
                {
                  label: "Maison",
                  value: "Habitation à un seul logement",
                  style: { flexBasis: "25%" },
                },
                {
                  label: "Appartement",
                  value: "Appartement",
                  style: { flexBasis: "45%" },
                },
                {
                  label: "Terrain",
                  value: "disabled1",
                  style: { flexBasis: "25%", ...fakeDisabled },
                },
                {
                  label: "Immeuble",
                  value: "disabled2",
                  style: { flexBasis: "25%", ...fakeDisabled },
                },
                {
                  label: "Bureaux",
                  value: "disabled3",
                  style: { flexBasis: "25%", ...fakeDisabled },
                },
              ]}
              defaultValue={"Appartement"}
              style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
              onChange={
                      (e) => {
                        if (e.target.value.includes('disabled')) {
                          displayContactUsModal();
                        }
                      }}
                    
            ></Radio.Group>
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Text style={advancedSearchTitle}>Surface</Text>
          <Form.Item name={["SurfaceBrutHab", 0]}>
            <Slider
              range
              defaultValue={[0, 2000]}
              min={0}
              max={2000}
              step={25}
              tooltip={{formatter}}
            />
          </Form.Item>
        </Col>
      </Row>
      <div style={{ display: 'flex', justifyContent: 'right' }}>
        <Button type="primary" htmlType="submit" onClick={() => setOpenFilters(false)}>
          OK
        </Button>
      </div>
    </Form>
  );
};

export default Filters;
